import PropTypes from 'prop-types';
import React, { Component } from 'react';

class MultiChoice extends Component {

    static canContinue(answer) {
        return !Boolean(answer && answer.choices && answer.choices.length > 0);
    }

    render() {
        const {id, config, answer} = this.props;
        const {choices = []} = answer;

        return (
            <ul className="multi-choice-list">
                {config.choices.map(({choice}, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index} className="multi-choice">
                        <input
                            id={`multi-choice-${id}-${index}`}
                            className="with-gap"
                            type="checkbox"
                            name="answer"
                            value={index}
                            onChange={this.onChange}
                            checked={choices.indexOf(index) >= 0}
                        />
                        <label htmlFor={`multi-choice-${id}-${index}`}>{choice}</label>
                    </li>
                ))}
            </ul>
        );
    }

    onChange = event => {
        const target = event.currentTarget;
        const choice = +target.value;
        const answer = this.props.answer;
        const {choices = []} = answer;
        const newChoices = [...choices];

        if (target.checked) newChoices.push(choice);
        else {
            const choiceIndex = newChoices.indexOf(choice);
            newChoices.splice(choiceIndex, 1);
        }

        return this.props.updateAnswer({choices: newChoices});
    };
}

MultiChoice.propTypes = {
    config: PropTypes.shape({
        choices: PropTypes.array.isRequired,
    }).isRequired,
    answer: PropTypes.shape({
        choices: PropTypes.array,
    }).isRequired,
    updateAnswer: PropTypes.func.isRequired,
    id: PropTypes.number,
};

MultiChoice.defaultProps = {
    id: 0,
};

export default MultiChoice;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/MultiChoice.js